<app-navbar></app-navbar>
<p-toast position="top-right" key="app-toast"></p-toast>
<div style="min-height: var(--dea-wrapper-height);">
  <router-outlet></router-outlet>
</div>
<app-footer></app-footer>
<p-confirmDialog [draggable]="false" [style]="{ width: '800px' }"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }" />